var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductionIssue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.04 15.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#cf0000;stroke-miterlimit:10;stroke-width:0.75px;}.cls-3{fill:#cf0000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.89,
    y: 0.38,
    width: 14.95,
    height: 13.48,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_charge_battery_172581",
    "data-name": "iconfinder charge battery 172581"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1780",
    "data-name": "Rectangle 1780",
    className: "cls-2",
    y: 1.03,
    width: 18.04,
    height: 14.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    className: "cls-3",
    d: "M6.11,12.22l.08-6.39,2.46.9,2-4.54-.07,6.39L8.08,7.69Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionIssue2);
export default __webpack_public_path__ + "static/media/production_issue2.d3b8d3cf8524ad375a58931d32fa0b7c.svg";
export { ForwardRef as ReactComponent };